import React, { FunctionComponent } from 'react';
import CandidatesPane from '../CandidatesPane';
import PositionsPane from '../PositionsPane';
import ProspectsPane from '../ProspectsPane';
import SurveysPane from '../SurveysPane';
import { Switch, Redirect, withRouter, RouteComponentProps } from 'react-router-dom';
import { Routes } from '../../../../common/enums/Routes';
import PrivateRoute from '../../../../containers/PrivateRoute';
import { dashboardTabs } from './utils';
import DashboardTab from '../../components/DashboardTab';

const DashboardPage: FunctionComponent<RouteComponentProps> = ({ location }) => (
  <>
    <div className="d-flex flex-nowrap page-indent tabs-wrapper">
      {dashboardTabs.map(({ name, icon }) => <DashboardTab key={name} name={name} icon={icon} />)}
    </div>
    <div className={`db-tab page-indent ${location.pathname === Routes.Prospects ? 'db-prospect-tab' : ''}`}>
      <Switch>
        <PrivateRoute exact path={Routes.Candidates} component={CandidatesPane} />
        <PrivateRoute exact path={Routes.Positions} component={PositionsPane} />
        <PrivateRoute exact path={Routes.Surveys} component={SurveysPane} />
        <PrivateRoute exact path={Routes.Prospects} component={ProspectsPane} />
        <Redirect to={Routes.Candidates} from={Routes.Dashboard} />
      </Switch>
    </div>
  </>
);

export default (withRouter(DashboardPage));
